export function RGBToHSL([r, g, b]) {
  r /= 255;
  g /= 255;
  b /= 255;
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  let h = (max + min) / 2;
  let s;
  const l = (max + min) / 2;
  if (max === min) {
    h = s = 0; // Achromatic
  } else {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r:
        h = (g - b) / d;
        break;
      case g:
        h = 2 + (b - r) / d;
        break;
      case b:
        h = 4 + (r - g) / d;
        break;
      default:
    }
    h *= 60;
    h = h < 0 ? h += 360 : h;
  }
  return [Math.floor(h), Math.floor(s * 100), Math.floor(l * 100)];
}
export function HEXToRGB(hexCode) {
  const match = hexCode.match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
  if (!match) {
    return [0, 0, 0];
  }
  let colorString = match[0];
  if (match[0].length === 3) {
    colorString = colorString.split('').map(char => char + char).join('');
  }
  const integer = parseInt(colorString, 16);
  const r = integer >> 16 & 0xff;
  const g = integer >> 8 & 0xff;
  const b = integer & 0xff;
  return [r, g, b];
}
export function HEXToHSL(hexCode) {
  const rgb = HEXToRGB(hexCode);
  return RGBToHSL(rgb);
}
//# sourceMappingURL=colorConverter.js.map